import { render, staticRenderFns } from "./bigPackageDetail.vue?vue&type=template&id=0e71ac67&scoped=true"
import script from "./bigPackageDetail.vue?vue&type=script&lang=js"
export * from "./bigPackageDetail.vue?vue&type=script&lang=js"
import style0 from "./bigPackageDetail.vue?vue&type=style&index=0&id=0e71ac67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71ac67",
  null
  
)

export default component.exports